
import defaultLayoutComponent from '~pages/layouts/DefaultLayoutComponents.js'
import AbstractLayout from '~pages/layouts/AbstractLayout.vue'

let routeInfo = [
  {
    path: 'payment',
    name: 'Payment',
    components: Object.assign({}, defaultLayoutComponent, { content: AbstractLayout }),
    beforeEnter: (to, from, next) => {
      console.log('payment root beforeEnter', to, from)
      next()
    },
    meta: {
      authorized: true
    },
    children: [
      {
        path: 'order',
        name: 'PaymentOrder',
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/payment/Payment.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment PaymentOrder beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '수강신청 및 결제'
        }
      },
      {
        path: 'result',
        name: 'PaymentDone',
        props: true,
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/payment/PaymentDone.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment paymentDone beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '결제 완료'
        }
      },
      {
        path: 'ars',
        name: 'PaymentArs',
        props: true,
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/payment/PaymentArs.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment PaymentArs beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: 'ARS 안내'
        }
      },
      {
        path: 'free',
        name: 'PaymentFree',
        props: true,
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/payment/PaymentFree.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment PaymentArs beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '무료 안내'
        }
      },
      {
        path: 'deposit',
        name: 'PaymentDeposit',
        props: true,
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/payment/PaymentDeposit.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment paymentDeposit beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '입금 안내'
        }
      },
      {
        path: 'nationDeposit',
        name: 'PaymentNationDeposit',
        props: true,
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/payment/PaymentNationDeposit.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment PaymentNationDeposit beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '입금 안내'
        }
      },
      {
        path: 'PkgDone',
        name: 'PaymentPkgDone',
        props: true,
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/payment/PaymentPkgDone.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment PaymentPkgDone beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '입금 안내'
        }
      },
      {
        path: 'TelCors',
        name: 'PaymentTelCors',
        component: () => import(/* webpackChunkName: "page_PaymentTelCors" */ '~pages/contents/payment/PaymentTelCors.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment PaymentTelCors beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '수강신청 및 결제'
        }
      },
      {
        path: 'SpeakCors',
        name: 'PaymentSpeakCors',
        component: () => import(/* webpackChunkName: "page_PaymentSpeakCors" */ '~pages/contents/payment/PaymentSpeakCors.vue'),
        beforeEnter: (to, from, next) => {
          console.log('payment PaymentSpeakCors beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: true,
          title: '수강신청 및 결제'
        }
      }
    ]
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/child/payment.js